import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { AssistantHumanAccessory } from "@/ui/AssistantAvatar/assistantAvatarConfig";
import { AvatarCoffee } from "../shared/AvatarCoffee";
import { AvatarFlower } from "../shared/AvatarFlower";

const { ACCESSORY } = ASSISTANT_AVATAR;

const Cap: FC = () => (
	<>
		<path d="M33 50 C33 26 46 19 60 19 C74 19 87 26 87 50 C74 42 46 42 33 50Z" fill={ACCESSORY.CAP} />
		<path d="M33 50 C46 42 74 42 87 50" fill="none" stroke={ACCESSORY.CAP_BRIM} strokeWidth={2.6} />
		{[
			[48, 30],
			[60, 26],
			[72, 30],
		].map(([cx, cy]) => (
			<circle key={cx} cx={cx} cy={cy} r={1.8} fill={ACCESSORY.CAP_DOT} />
		))}
	</>
);

const Headphones: FC = () => (
	<>
		<path d="M33 58 C33 22 87 22 87 58" fill="none" stroke={ACCESSORY.INK} strokeWidth={4.5} strokeLinecap="round" />
		{[27, 82].map((x) => (
			<rect key={x} x={x} y={51} width={11} height={19} rx={5} fill={ACCESSORY.HEADPHONE_CUP} stroke={ACCESSORY.INK} strokeWidth={2.2} />
		))}
	</>
);

const HearingAid: FC = () => (
	<>
		<path d="M86 55 C93 56 93 67 87.5 69" fill="none" stroke={ACCESSORY.HEARING_AID} strokeWidth={4} strokeLinecap="round" />
		<circle cx={85} cy={63} r={1.9} fill={ACCESSORY.INK} />
	</>
);

/** Accessories drawn over the hair; the figure places glasses, shades and the stethoscope itself. */
const ACCESSORIES: Record<AssistantHumanAccessory, FC | null> = {
	[AssistantHumanAccessory.None]: null,
	[AssistantHumanAccessory.Glasses]: null,
	[AssistantHumanAccessory.Shades]: null,
	[AssistantHumanAccessory.Stethoscope]: null,
	[AssistantHumanAccessory.Cap]: Cap,
	[AssistantHumanAccessory.Headphones]: Headphones,
	[AssistantHumanAccessory.HearingAid]: HearingAid,
	[AssistantHumanAccessory.Coffee]: AvatarCoffee,
	[AssistantHumanAccessory.Flower]: () => <AvatarFlower transform="translate(80 34) scale(.8)" />,
};

export const HumanAccessory: FC<{ accessory: AssistantHumanAccessory }> = ({ accessory }) => {
	const Accessory = ACCESSORIES[accessory];
	return Accessory ? <Accessory /> : null;
};
